var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[[_c('el-backtop',{attrs:{"target":"#app"}},[_c('div',{staticClass:"back-ball"},[_vm._v(" 回到顶部 ")])])],_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }